export class BaseFlowModalActionConfig {
  actionFn?: () => void;
  iconClass?: string;

  constructor(config: Partial<BaseFlowModalActionConfig> = {}) {
    this.actionFn = config.actionFn;
    this.iconClass = config.iconClass;
  }
}
